import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiLogOut, FiUser } from "react-icons/fi";
import { useRole } from "../../hooks/useRole";
import { useLocation } from "react-router-dom";
import ThemeToggle from "../../components/common/ThemeToggle.jsx";
import { buildApiUrl, API_ENDPOINTS } from "../../config/api";
import { apiRequest } from "../../utils/apiUtils";

const navbarStyle = {
  width: "100%",
  position: "sticky",
  top: 0,
  zIndex: 1000,
  backgroundColor: "var(--bg-secondary)",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0 20px",
  height: "60px",
  boxShadow: "0 2px 6px var(--shadow-color)",
  borderBottom: "1px solid var(--border-primary)",
};

const userButtonStyle = {
  background: "none",
  border: "none",
  cursor: "pointer",
};

const dropdownStyle = {
  position: "absolute",
  top: "60px",
  right: "20px",
  backgroundColor: "var(--bg-secondary)",
  border: "1px solid var(--border-primary)",
  borderRadius: "5px",
  padding: "10px 0",
  zIndex: 1001,
  minWidth: "180px",
  boxShadow: "0 4px 8px var(--shadow-medium)",
  fontSize: "11px",
};

const dropdownItemStyle = {
  padding: "10px 20px",
  color: "var(--text-primary)",
  textDecoration: "none",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  cursor: "pointer",
  whiteSpace: "nowrap",
};

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAdmin } = useRole();
  const mostrarCambioOrg = isAdmin && location.pathname !== "/orgselector";
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);
  const [isDark, setIsDark] = useState(
    !document.body.classList.contains("light-theme")
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(!document.body.classList.contains("light-theme"));
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    return () => observer.disconnect();
  }, []);

  const handleLogout = async () => {
    try {
      // Llamar al endpoint de logout del backend para limpiar la cookie
      await apiRequest(buildApiUrl(API_ENDPOINTS.logout), {
        method: "POST",
      });
      // Logout exitoso
    } catch (error) {
      console.error("❌ Error durante logout:", error);
      // Continuar con la limpieza local aunque falle el backend
    } finally {
      // Limpiar localStorage y redirigir
      localStorage.clear();
      navigate("/login");
    }
  };

  // Cerrar el menú si se hace clic fuera
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setShowMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header style={navbarStyle}>
      <div>

        {mostrarCambioOrg && (
          <Link
            to="/orgselector"
            style={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              color: "var(--accent-color)",
              textDecoration: "none",
              fontSize: "11px",
              border: "1px solid var(--border-primary)",
              padding: "6px 10px",
              borderRadius: "5px",
            }}
          >
            Cambiar Empresa
          </Link>
        )}
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
        <ThemeToggle />

        <div style={{ position: "relative" }} ref={menuRef}>
          <button
            onClick={() => setShowMenu(!showMenu)}
            style={userButtonStyle}
          >
            <FiUser
              style={{
                width: "28px",
                height: "28px",
                color: "#fff",
                backgroundColor: isDark ? "#C3C3C3" : "#53565A",
                borderRadius: "50%",
                padding: "4px",
                boxSizing: "border-box",
              }}
            />
          </button>

          {showMenu && (
            <div style={dropdownStyle}>
              <Link to="/perfil" style={dropdownItemStyle}>
                Mi perfil
              </Link>
              <div onClick={handleLogout} style={{ ...dropdownItemStyle }}>
                <FiLogOut
                  style={{
                    width: "18px",
                    height: "18px",
                    color: "#fff",
                    backgroundColor: isDark ? "#C3C3C3" : "#53565A",
                    borderRadius: "50%",
                    padding: "2px",
                    flexShrink: 0,
                  }}
                />

                <span>Cerrar sesión</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Navbar;
